import React, { useEffect } from 'react';
import authService from '../services/authService';
import Logo from '../components/Logo';

const Logout = ({ onLogout }) => {
  useEffect(() => {
    (async () => {
      await authService.logout();
      onLogout();
      window.location.href = '/login';
    })();
  }, [onLogout]);

  return (
    <div className="flex justify-center items-center h-screen bg-brand-gradient-deep font-sans">
      <div className="w-full max-w-[420px] bg-white p-10 rounded-2xl shadow-2xl text-center">
        <Logo className="h-9 w-auto mx-auto mb-4" />
        <p className="text-slate-500 text-sm">Signing you out…</p>
      </div>
    </div>
  );
};

export default Logout;
